<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "timer" [fullScreen] = "false"><p style="color: white" > 
            Loading... </p></ngx-spinner>
        <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->
        <div class="card">
            <div class="card-header">แบบฟอร์มขอปุ๋ย</div>
            <div class="card-body">
                <div class="row">
                <!-- รายการชาวไร่  -->

                    <div class="col-8">
                        <div class="card">
                            <div class="card-body">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon1">ปุ๋ยรอบที่ 3 65/66</span>
                                    <input type="text" class="form-control" placeholder="ป้อนรหัสโควต้า" list="farmer" id="codefm">
                                    <datalist  id="farmer">
                                        <option *ngFor="let item of famerlist">[{{item.fmcode_b1}}] {{item.fmname}} จำนวนแปลง {{item.cnt}}</option>
                                    </datalist>
                                    <button class="btn btn-outline-dark" (click)="goloaddata();"><i class="fas fa-search"></i></button>
                                </div>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <td>เลขแปลง</td>
                                            <td>โซน</td>
                                            <td>ประเภท</td>
                                            <td>พื้นที่</td>
                                            <td>ประเมิน</td>
                                            <td>เบิกแล้ว</td>
                                            <td>คงเหลือ</td>
                                            <td>เลือก</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            <tr *ngFor="let item of dataonefarmer">
                                                <td>{{item.intlandno}}</td>
                                                <td>{{item.supzone}}</td>
                                                <td>{{item.CaneTypeName}}</td>
                                                <td>{{item.landvalue}}</td>
                                                <td>{{item.Assess}}</td>
                                                <td>{{item.Assess}}</td>
                                                <td>{{item.Assess}}</td>
                                                <td><button class="btn btn-success" (click)="gocheckonedata(item.itid);"><i class="fas fa-check-circle"></i></button></td>
                                                <!-- <td>{{item.MIl_grSzhmWOgOchyTs}}</td> -->
                                            </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                      
                    </div>
                  <!-- รายการชาวไร่  -->

                     <!-- ฟอร์มบันทึกกรอกปุ๋ย -->
                <div class="col-4">
                    <div class="card">
                        <div class="card-header bg-warning">ฟอร์มขอปุ๋ยรอบ [{{fname}}] </div>
                        <div class="card-body">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td>แปลง</td>
                                        <td><input type="text" class="form-control" [value]="plantno" disabled></td>
                                    </tr>
                                    <tr>
                                        <td>สูตรปุ๋ย</td>
                                        <td>
                                            <select class="form-control" >
                                                <option value="00">กรุณาเลือก</option>
                                                <option *ngFor="let item of fertilizercode" [ngvalue]="item.stock_id">{{item.description}}</option>
                                            </select>
                                            
                                           
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>สต๊อค </td>
                                        <td>
                                            <select class="form-control">
                                                <option value="00">กรุณาเลือก</option>
                                                <option *ngFor="let item of fertilizerstock" [ngvalue]="item.StockID">{{item.Stockname}}</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>จำนวน</td>
                                        <td>
                                            <input type="number" min="1" class="form-control">
                                        </td>
                                    </tr>
                                </tbody>
                            </table> <hr>
                            <button class="btn btn-info">บันทึก</button>  <button class="btn btn-default float-right">กรอกใหม่</button> 
                        </div>
                    </div>    
                </div>
                <!-- ฟอร์มบันทึกกรอกปุ๋ย -->
                </div>
                
               
            </div>
        </div>
        <!-- แบบบันทึกทั้งหมดนั่นล่ะ -->

        <div class="card">
            <div class="card-header">
                <i class="fas fa-table"></i> ข้อมูลการเบิกปุ๋ยของปีนี้
            </div>
            <div class="card-body">
                
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>